import { VisitaEstado } from '../Visitas/consts/visitasStatus';

// SMP-395: GET /roam/siniestros/:id/visitas no expone un id de motivo, solo
// `motivoFalla: { codigo, descripcion }`, con una numeracion de codigo propia (distinta a la
// de los ids del catalogo GET /visitas/motivos-falla que usa motivoFallaDestino.ts). Confirmado
// contra el backend de dev: el codigo del motivo "Lugar de ocurrencia erroneo (siniestros)" es "09".
export const CODIGO_MOTIVO_LUGAR_OCURRENCIA_ERRONEO = '09';

interface VisitaConMotivoFalla {
    idEstado?: number;
    motivoFalla?: { codigo?: string; descripcion?: string } | null;
}

// Siniestro Pendiente (sin visitas todavia): edicion libre (SMP-283). Abierto: solo se habilita
// si alguna visita esta Pendiente con marca de fallida por el motivo "Lugar de ocurrencia
// erroneo (siniestros)" (SMP-395, Escenario 3); en cualquier otro caso - visita abierta sin
// marca de fallida, o fallida por otro motivo - queda bloqueado (Escenario 5). Finalizado/
// Cancelado: siempre bloqueado, independientemente de las visitas (SMP-283).
export const canEditOccurrenceLocation = (
    idEstadoSiniestro: number | undefined,
    visitas: VisitaConMotivoFalla[]
): boolean => {
    if (idEstadoSiniestro === 2) {
        return visitas.some(
            (visita) =>
                visita?.idEstado === VisitaEstado.PENDIENTE &&
                visita?.motivoFalla?.codigo === CODIGO_MOTIVO_LUGAR_OCURRENCIA_ERRONEO
        );
    }

    return idEstadoSiniestro === 1;
};
